// @flow
import React from "react";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  getJanelaMovelSelecionada,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarPeriodoSemPeriodicidade = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const janelaMovel = getJanelaMovelSelecionada(state);

    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      periodicidade: edicaoMedida.periodicidade,
      ajusteDias: edicaoMedida.ajusteDias,
      dataBase: dataBase,
      janelaMovel: janelaMovel,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
);

const PeriodoSemPeriodicidade = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <SelecaoAjusteDias />
        <SelecaoCasasDecimais />
      </>
    );
  }
};

export default PeriodoSemPeriodicidade;
